import { createSlice } from "@reduxjs/toolkit";
import { ISelectedDatapieceParams } from "../../interfaces/interfaces";

interface IState {
  selectedDatapiece?: {
    isExpanded: boolean;
    params: ISelectedDatapieceParams | null;
  } | null;
  insightGenerated?: boolean;
}

const INITIAL_STATE: IState = {
  selectedDatapiece: { isExpanded: false, params: null },
  insightGenerated: false,
};

const goalsIdeasMoves = createSlice({
  name: "goalsIdeasMoves",
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedDatapiece: (state, actions) => {
      state.selectedDatapiece = actions.payload;
    },
    setInsightGenerated: (state, actions) => {
      state.insightGenerated = actions.payload;
    },
  },
});

export const { setSelectedDatapiece, setInsightGenerated } =
  goalsIdeasMoves.actions;

export const goalsIdeasMovesReducer = goalsIdeasMoves.reducer;
